import { IChevronLeftProps } from "interfaces";

const ChevronLeftIcon = ({ className, onClick }: IChevronLeftProps) => {
    return (
        <svg viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <path d="M6.00781 10.6665L1.3657 6.02439L6.00781 1.38228" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default ChevronLeftIcon;
